import axios from "axios"
import { Upload, Button, Modal, Spin } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { warning } from "../../../helpers"
import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { getDocumentAws, setDocument, DeleteDocumentAws } from "../../../helpers"
import { useAuth } from "../../../contexts/auth"
import { useMutation } from "@apollo/client"
import { createDownloadLog } from "../../../graphql/submission/mutations/createDownloadLog"

StatefulUploadButtonForm.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onRemoveFile: PropTypes.func,
  fileList: PropTypes.arrayOf(PropTypes.shape({
    uid: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    url: PropTypes.string
  })),
  maxFile: PropTypes.number,
  accept: PropTypes.string
}

export function StatefulUploadButtonForm ({
  children,
  disabled = false,
  onChange,
  onRemoveFile,
  fileList = [],
  maxFile = 1,
  accept
}) {
  const isDisabled = disabled || fileList?.length >= maxFile
  const [state, setState] = useState({ fileList, disabled: isDisabled })
  const [files, setFiles] = useState(fileList)
  const [uploading, setUploading] = useState(false)
  

  useEffect(() => {
    if (fileList) {
      setState({ fileList, disabled: isDisabled })
      setFiles(fileList)
    }
  }, [fileList])


  const onUploadChange = async (Archivo, status) => {
    let fileList = [...state.fileList, Archivo]
    fileList = fileList.slice(-maxFile)
    
    setState({ fileList, disabled: fileList.length >= maxFile })
    if (status === "done") {
      onChange && onChange(fileList)
    } else if (status === "error") {
      warning("Ha ocurrido un error al subir el archivo, inténtalo de nuevo en unos segundos.")
    }
    setUploading(false)
  }

   const auth = useAuth()
   const userAuthDownload = auth?.user?.claims ?? {}
  
  /** Function to register data of downloaded documents **/

   const handleDownload = ( file ) => {
 
     getDocumentAws(file.url)
 
     if (!userAuthDownload) {
       console.error("No user information available")
       return
     }
 
     const downloadInfo = {
       email: userAuthDownload.email,
       userName: userAuthDownload.name,
       role: userAuthDownload.role,
       uid: userAuthDownload.user_id,
       documentName: file.name,
       //type: file.type
     }
 
     trackDownload({
       variables: { data: downloadInfo }
     })
       .catch((error) => {
         console.error(error)
       })
 
   }
 
  const [trackDownload] = useMutation(createDownloadLog)
 
  const setAws = async(file) => {
      setUploading(true)
      const response = await setDocument(file)
      onUploadChange(response, "done")
    }
  
  return (
    <>
    <Upload 
      fileList={state.fileList}
      beforeUpload={async (file) => {
       
        const uploadedFile = await setAws(file);

        if (!uploadedFile) return false;
        return false
      }}
      onRemove={file => {
        const { confirm } = Modal
        return new Promise(resolve => {
          confirm({
            width: 500,
            title: `Estás seguro de eliminar ${file.name}?`,
            content: "Si lo eliminas, no podrás recuperarlo.",
            onOk: async () => {
                const resposne = await DeleteDocumentAws(file)
                if (resposne){
                   resolve(true)
                   onRemoveFile(file)
                }else{
                   resolve(false)
                   warning("Ha ocurrido un error al intentar eliminar el archivo.");
                }
            }
          })
        })
      }}
      accept={accept}
      onPreview={(file) => {
        handleDownload(file)
      }}
      showUploadList={{
        showRemoveIcon: !disabled,
        itemRender: (originNode, file) => (
          <div
        style={{ cursor: "pointer", color: "#612F5E" }}
        onClick={(event) => {
          event.preventDefault(); 
          handleDownload(file);
        }}
      >
        {file.name}
      </div>
        ),
      }}
      multiple>
      <Button disabled={state.disabled}>
        <UploadOutlined /> {children}
      </Button>
    </Upload>

    {uploading && 
         <div className="project-loading">
              <Spin tip="Subiendo Archivo"/>
          </div>
        }
    </>
  )
}
